import React, { useMemo } from 'react';
import { RetryIcon } from '@Generic/icons';
import { useTranslation } from 'react-i18next';

const useTryAgainErrorButton = (reset) => {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      label: t('error-page.try-again', 'Try again'),
      iconStart: <RetryIcon />,
      isPrimary: false,
      onClick: reset,
    }),
    [t, reset],
  );
};

export default useTryAgainErrorButton;
